export default __webpack_public_path__ + "media/zurb/img/services/design-insight/design-insight-img1-12eab5571c37d3e88bde25d6fba8990f.png";